<trp-base-layout
  [fitContent]="true"
  [collapsedMenu]="menu.isCollapsed$ | async"
>
  <ng-container
    trp-layout-topbar
    *ngIf="{
      isSignedIn: user.isSignedIn$ | async,
      stateName: stateName$ | async
    } as data"
  >
    <community-topbar
      *ngIf="data.isSignedIn === false && data.stateName !== null"
      [stateName]="data.stateName"
    ></community-topbar>
  </ng-container>
  <community-sidebar
    *ngIf="(user.isSignedIn$ | async) === true"
    trp-layout-sidebar
  ></community-sidebar>
  <div class="content-wrapper" trp-layout-content>
    <community-banner-container
      *ngIf="notificationFacade.hasNotifications$ | async"
      class="mat-elevation-z6"
    ></community-banner-container>

    <div class="routed-content">
      <router-outlet></router-outlet>
    </div>
    <footer>
      <ng-container #footerContainer></ng-container>
    </footer>
  </div>
</trp-base-layout>

<trp-global-loader></trp-global-loader>
